var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var TwitterSvg = /* @__PURE__ */ __name(function TwitterSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M3.498 5.333c2.951 3.59 7.296 5.94 12.195 6.22l0.045 0.002c-0.036-0.369-0.080-0.702-0.102-1.040-0.012-0.137-0.019-0.296-0.019-0.456 0-1.194 0.38-2.298 1.026-3.2l-0.011 0.017c1.043-1.614 2.833-2.667 4.869-2.667 0.288 0 0.571 0.021 0.847 0.062l-0.031-0.004c1.323 0.145 2.487 0.734 3.36 1.613l0 0c0.089 0.101 0.219 0.164 0.363 0.164 0.056 0 0.11-0.010 0.16-0.027l-0.003 0.001c1.177-0.272 2.215-0.678 3.172-1.213l-0.060 0.031 0.351-0.182c-0.451 1.352-1.319 2.464-2.448 3.212l-0.023 0.014c1.198-0.142 2.288-0.423 3.315-0.831l-0.088 0.031c-0.209 0.284-0.409 0.573-0.636 0.844-0.616 0.752-1.302 1.41-2.059 1.978l-0.030 0.022c-0.109 0.074-0.18 0.197-0.18 0.336 0 0.015 0.001 0.029 0.002 0.043l-0-0.002c0.004 0.142 0.007 0.309 0.007 0.476 0 3.834-1.252 7.375-3.369 10.238l0.033-0.047c-1.938 2.735-4.664 4.798-7.844 5.874l-0.111 0.033c-1.645 0.572-3.542 0.902-5.515 0.902-0.817 0-1.62-0.057-2.407-0.166l0.091 0.010c-2.57-0.336-4.882-1.218-6.89-2.528l0.063 0.039c0.378 0.042 0.816 0.065 1.26 0.065 2.81 0 5.397-0.953 7.457-2.553l-0.027 0.021c-2.702-0.236-4.538-1.6-5.547-4.147 0.318 0.057 0.683 0.089 1.057 0.089 0.572 0 1.127-0.076 1.654-0.219l-0.044 0.010c-1.391-0.303-2.572-1.058-3.409-2.099l-0.009-0.012c-0.806-0.989-1.294-2.264-1.294-3.654 0-0.034 0-0.069 0.001-0.103l-0 0.005c0.444 0.164 0.844 0.356 1.271 0.476 0.386 0.101 0.841 0.177 1.307 0.212l0.026 0.002c-1.19-0.866-2.049-2.124-2.392-3.58l-0.008-0.042c-0.097-0.402-0.153-0.863-0.153-1.337 0-1.080 0.289-2.092 0.795-2.963l-0.015 0.028z"
  }));
}, "TwitterSvg");
var TwitterIcon = /* @__PURE__ */ __name(function TwitterIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: TwitterSvg
  }, props));
}, "TwitterIcon");
export {
  TwitterIcon
};
